import { whenAyReady, withAyManager } from './queue'

/**
 * Write AY custom dimensions once the SDK is up. `build` runs at that point, so it
 * reads state as it is then, not when the write was queued.
 */
export function writeCustomDimensions(
  build: () => Record<string, unknown>
): void {
  whenAyReady(() => {
    const custom = window.assertive?.analytics?.custom
    if (custom) {
      Object.assign(custom, build())
    }
  })
}

/**
 * Writing straight into `window.assertive.analytics.custom` on a consent
 * click can race AY's own refresh-cycle targeting and trip its "Improper use
 * of ad refresh" check. Defer the write to `beforeRefresh` — AY's hook for
 * "before the auctions run", the point it expects targeting changes — so the
 * write lands ahead of the very refresh a consent `allow` triggers. The patch
 * is cleared once applied, so the persistent listener writes exactly once.
 */
let pendingPatch: Record<string, unknown> | null = null
let beforeRefreshHandlerRegistered = false

const applyPendingPatch = () => {
  if (pendingPatch && window.assertive?.analytics?.custom) {
    Object.assign(window.assertive.analytics.custom, pendingPatch)
    pendingPatch = null
  }
}

export const queueCustomPatch = (patch: Record<string, unknown>) => {
  pendingPatch = { ...pendingPatch, ...patch }

  if (!beforeRefreshHandlerRegistered) {
    beforeRefreshHandlerRegistered = true
    withAyManager(() => {
      window.ayManagerEnv?.onEvent('beforeRefresh', applyPendingPatch)
    })
  }
}
